module.exports = __webpack_public_path__ + "img/pic2.fae34502.jpg";